/**
 * VendorProductMediaTypeService
 * Service for managing vendor product media types
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor product media type CRUD operations
 */
export class VendorProductMediaTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorProductMediaTypeService.DEFAULT_SERVICE_PATH,
            basePath: VendorProductMediaTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VendorProductMediaTypeService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorProductMediaTypeService.BASE_PATH = 'api/vendor-product-media-types';
//# sourceMappingURL=VendorProductMediaTypeService.js.map